import React from "react";
import { Routes, Route } from "react-router-dom";
import AboutDetail from "./about-detail";

//
const About = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<AboutDetail />} />
         <Route path="/" element={<AboutDetail />} />
      </Routes>
    </React.Fragment>
  );
};

export default About;
